// this is a workaround for a bug in volto-slate that causes the editor to crash
// It's a wrapper around `Editor.nodes` that catches errors when the selection is invalid or out of bounds.
// TODO #851: remove this component when bug in volto-slate is fixed (related to Toolbar.jsx)
import { Editor } from 'slate';

export function safeEditorNodes(editor, options) {
  try {
    return Array.from(Editor.nodes(editor, options));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('safeEditorNodes: selection invalid or out of bounds:', {
      options,
      selection: editor.selection,
      error: e,
    });
    return [];
  }
}
